export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        value = value.replace(/[^a-zA-Z0-9]/g, '');

        return !!(value.match(/^(([135-7][0-9])|(2[5-9])|(4[0-467]))[0-9]{3}$/));
    }
}

